export default __webpack_public_path__ + "static/media/liquidation.f048fbb5.png";